import dayjs, { Dayjs } from 'dayjs'
import calendarJs from 'calendar'
import JapaneseHolidays from '@holiday-jp/holiday_jp'

class DatePicker {
  /**
   * array // カレンダーの配列を作成する
   *
   * @param {dayjs} calendarDate
   * @param {dayjs} nowDate
   * @param {string} regulationDate
   *
   * @return {array}
   */
  array(calendarDate, nowDate, regulationDate) {
    const date = dayjs(calendarDate)
    const year = date.year()
    const month = date.month()
    const calendar = new calendarJs.Calendar(1).monthDays(year, month)
    this.holidays = JapaneseHolidays.between(new Date(`${year}-01-01`), new Date(`${year + 1}-01-01`))
    return calendar.map(week => {
      return week.map(day => {
        const monthNum = month + 1 // 実数値に変換
        const isHoliday = this.isHoliday(dayjs(`${year}-${monthNum}-${day}`).format('YYYY-MM-DD'))
        const isDisable = this.isDisableDate(dayjs(`${year}-${monthNum}-${day}`), regulationDate)
        const isSelected = this.isSameDay(nowDate, `${year}-${monthNum}-${day}`)
        return {
          day: day,
          date: `${year}-${monthNum}-${day}`,
          isSelected,
          isHoliday,
          isDisable,
        }
      })
    })
  }

  /**
   * isHoliday // 祝日か判定する
   *
   * @param {string} date
   *
   * @return {boolean}
   */
  isHoliday(date) {
    return Boolean(this.holidays.find(val => this.dateFormat(val.date) === date))
  }

  /**
   * disableDate // 過去日判定
   *
   * @param {Dayjs} date1
   * @param {Dayjs} date2
   *
   * @return {boolean}
   */
  isDisableDate(date1, date2) {
    return date1.isBefore(date2)
  }

  dateFormat(d) {
    return `${d.getFullYear()}-
${(d.getMonth() + 1).toString().padStart(2, '0')}-
${d.getDate().toString().padStart(2, '0')}`.replace(/\n|\r/g, '')
  }

  /**
   * yearManager // 年度を変更する
   *
   * @param {number} year // 現在の年
   * @param {number} month // 丸める前の月
   *
   * @return {number}
   */
  yearManager(year, month) {
    // 数値が大きければ次の年
    if (month > 12) return year + 1

    // 数値が小さい場合は次の年
    if (month < 1) return year - 1

    // それ以外
    return year
  }

  /**
   * monthManager // 月を1 ~ 12に丸める
   *
   * @param {number} month
   *
   * @return {number} 1 ~ 12
   */
  monthManager(month) {
    month %= 12
    if (month < 1) {
      month += 12
    }
    return month
  }

  /**
   * isNowAfterMonth.
   *
   * @param {number} year
   * @param {number} month
   *
   * @return {boolean}
   */
  isNowAfterMonth(year, month) {
    return dayjs().isAfter(dayjs(`${year}-${month}`), 'month')
  }

  /**
   * renderMonth.
   *
   * @param {string | number} month
   * @return {string} // 〇〇月
   */
  renderMonth(month) {
    return `${month}月`
  }

  /**
   * isSameDay // 同じ日付か比較する
   *
   * @param {string} date1 // 2020-12-01
   * @param {string} date2 // 2020-12-01
   *
   * @return {boolean}
   */
  isSameDay(date1, date2) {
    return dayjs(date1).isSame(dayjs(date2), 'day')
  }

  /**
   * nextMonth.
   *
   * @param {Dayjs} date
   *
   * @return {Dayjs}
   */
  nextMonth(date) {
    const year = this.yearManager(date.year(), date.month() + 2) // 表示と次の月で+2
    const month = this.monthManager(date.month() + 2)
    return dayjs(`${year}-${month}-01`)
  }
}

export default new DatePicker()
